import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getSampleList = createAsyncThunk(
  "get-sample",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("product/sample/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createSample = createAsyncThunk(
  "create-sample",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("product/sample", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const editSample = createAsyncThunk(
  "edit-sample",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`product/sample/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateSample = createAsyncThunk(
  "update-sample",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`product/sample/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const returnSample = createAsyncThunk(
  "return-sample",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`product/sample/return/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteSample = createAsyncThunk(
  "delete-sample",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`product/sample/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const sampleSlice = createSlice({
  name: "sample",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSampleList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSampleList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.sampleList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getSampleList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default sampleSlice.reducer;
